export const testids = {
  EVENT_HISTORY_TABLE_ITEM: 'EVENT_HISTORY_TABLE_ITEM',
  EVENT_HISTORY_TABLE_MAP_LINK: 'EVENT_HISTORY_TABLE_MAP_LINK',
  UPLOAD_FILE_IMAGE_LIST_ITEM: 'UPLOAD_FILE_IMAGE_LIST_ITEM',
  UPLOAD_FILE_IMAGE_LIST_ITEM_DELETE: 'UPLOAD_FILE_IMAGE_LIST_ITEM_DELETE',
  UPLOAD_FILE_IMAGE_LIST_ITEM_VIEW: 'UPLOAD_FILE_IMAGE_LIST_ITEM_VIEW',
  UPLOAD_FILE_IMAGE_LIST_WRAPPER: 'UPLOAD_FILE_IMAGE_LIST_WRAPPER',
  UPLOAD_FILE_FORM_WRAPPER: 'UPLOAD_FILE_FORM_WRAPPER',
  UPLOAD_FILE_LABEL: 'UPLOAD_FILE_LABEL',
  INFO_TAB_CLOSE_BUTTON: 'INFO_TAB_CLOSE_BUTTON',
  POPUP: 'POPUP',
  POPUP_CLOSE_BUTTON: 'POPUP_CLOSE_BUTTON',
  POPUP_CANCEL_BUTTON: 'POPUP_CANCEL_BUTTON',
  POPUP_ACTION_BUTTON: 'POPUP_ACTION_BUTTON',
  TABLE_REFETCH_TABLE_DATA_BUTTON: 'TABLE_REFETCH_TABLE_DATA_BUTTON',
  page_auth: {
    AUTH_FORM: 'AUTH_FORM',
    AUTH_INPUT_LOGIN: 'AUTH_INPUT_LOGIN',
    AUTH_INPUT_PASSWORD: 'AUTH_INPUT_PASSWORD',
    AUTH_INPUT_REMEMBER: 'AUTH_INPUT_REMEMBER',
    AUTH_BUTTON_ENTER: 'AUTH_BUTTON_ENTER',
  },
  widget_navbar: {
    NAVBAR_INPUT_CHOOSE_FILIAL_INPUT: 'NAVBAR_INPUT_CHOOSE_FILIAL',
    NAVBAR_INPUT_CHOOSE_FILIAL_WRAPPER_INPUT: 'NAVBAR_INPUT_CHOOSE_FILIAL',
    NAVBAR_INPUT_CHOOSE_FILIAL_LIST: 'NAVBAR_INPUT_CHOOSE_FILIAL_LIST',
    NAVBAR_INPUT_CHOOSE_FILIAL_OPEN_LIST_ITEM: 'NAVBAR_INPUT_CHOOSE_FILIAL_OPEN_LIST_ITEM',
    NAVBAR_POPUP_BUTTON: 'NAVBAR_POPUP_BUTTON',
    NAVBAR_POPUP_CHANGE_PASSWORD_BUTTON: 'NAVBAR_POPUP_CHANGE_PASSWORD_BUTTON',
    NAVBAR_POPUP_CHANGE_EXIT_BUTTON: 'NAVBAR_POPUP_CHANGE_EXIT_BUTTON',
    NAVBAR_LINK: [
      'NAVBAR_LINK_EVENTS',
      'NAVBAR_LINK_USERS',
      'NAVBAR_LINK_ROLES',
      'NAVBAR_LINK_GROUPS',
      'NAVBAR_LINK_TRANSPORT',
      'NAVBAR_LINK_ALCOLOCKS',
      'NAVBAR_LINK_AVTOSERVISE',
      'NAV_LINKS_LINKS',
    ],
  },

  page_events: {
    events_widget_header: {
      EVENTS_WIDGET_HEADER_SEARCH_INPUT: 'EVENTS_WIDGET_HEADER_SEARCH_INPUT',
      EVENTS_WIDGET_HEADER_FROM_DATE: 'EVENTS_WIDGET_HEADER_FROM_DATE',
      EVENTS_WIDGET_HEADER_TO_DATE: 'EVENTS_WIDGET_HEADER_TO_DATE',
      EVENTS_WIDGET_HEADER_FILTER_BUTTON: 'EVENTS_WIDGET_HEADER_FILTER_BUTTON',
      EVENTS_WIDGET_HEADER_FILTER_INPUT_DRIVER: 'EVENTS_WIDGET_HEADER_FILTER_INPUT_DRIVER',
      EVENTS_WIDGET_HEADER_FILTER_INPUT_BRAND_CAR: 'EVENTS_WIDGET_HEADER_FILTER_INPUT_BRAND_CAR',
      EVENTS_WIDGET_HEADER_FILTER_INPUT_GOS_NUMBER: 'EVENTS_WIDGET_HEADER_FILTER_INPUT_GOS_NUMBER',
      EVENTS_WIDGET_HEADER_FILTER_INPUT_TYPE_EVENT: 'EVENTS_WIDGET_HEADER_FILTER_INPUT_TYPE_EVENT',
    },
    events_widget_table: {
      EVENTS_WIDGET_TABLE: 'EVENTS_WIDGET_TABLE',
      EVENTS_WIDGET_TABLE_HEADER_ITEM: 'EVENTS_WIDGET_TABLE_HEADER_ITEM',
      EVENTS_WIDGET_TABLE_BODY_ITEM: 'EVENTS_WIDGET_TABLE_BODY_ITEM',
    },
    events_widget_info: {
      EVENTS_WIDGET_INFO_MAPLINK: 'EVENTS_WIDGET_INFO_MAPLINK',
    },
  },
  page_users: {
    users_widget_header: {
      USERS_WIDGET_HEADER_SEARCH_INPUT: 'USERS_WIDGET_HEADER_SEARCH_INPUT',
      USERS_WIDGET_HEADER_FROM_DATE: 'USERS_WIDGET_HEADER_FROM_DATE',
      USERS_WIDGET_HEADER_TO_DATE: 'USERS_WIDGET_HEADER_TO_DATE',
    },
    users_widget_table: {
      USERS_WIDGET_TABLE: 'USERS_WIDGET_TABLE',
      USERS_WIDGET_TABLE_HEADER_ITEM: 'USERS_WIDGET_TABLE_HEADER_ITEM',
      USERS_WIDGET_TABLE_BODY_ITEM: 'USERS_WIDGET_TABLE_BODY_ITEM',
      USERS_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT: 'USERS_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT',
      USERS_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE: 'USERS_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE',
      USERS_WIDGET_TABLE_BODY_ITEM_ACTION_ADD: 'USERS_WIDGET_TABLE_BODY_ITEM_ACTION_ADD',
    },
    users_widget_info: {
      USERS_WIDGET_INFO_TAB_BUTTON_INFO: 'USERS_WIDGET_INFO_TAB_BUTTON_INFO',
      USERS_WIDGET_INFO_TAB_BUTTON_HISTORY: 'USERS_WIDGET_INFO_TAB_BUTTON_HISTORY',
      USERS_WIDGET_INFO_TAB_BUTTON_PHOTOS: 'USERS_WIDGET_INFO_TAB_BUTTON_PHOTOS',
    },
    users_widget_add_user_popup: {
      USERS_WIDGET_ADD_USER_POPUP_CLOSE_POPUP_BUTTON:
        'USERS_WIDGET_ADD_USER_POPUP_CLOSE_POPUP_BUTTON',
      USERS_WIDGET_ADD_USER_POPUP_ADD_FOTO: 'USERS_WIDGET_ADD_USER_POPUP_ADD_FOTO',
      USERS_WIDGET_ADD_USER_POPUP_ADD_USER_BUTTON: 'USERS_WIDGET_ADD_USER_POPUP_ADD_USER_BUTTON',
      USERS_WIDGET_ADD_USER_POPUP_CANCEL_USER_BUTTON:
        'USERS_WIDGET_ADD_USER_POPUP_CANCEL_USER_BUTTON',
      USERS_WIDGET_ADD_USER_POPUP_NAME_USER_INPUT: 'USERS_WIDGET_ADD_USER_POPUP_NAME_USER_INPUT',
      USERS_WIDGET_ADD_USER_POPUP_DATE_BIRTH_INPUT: 'USERS_WIDGET_ADD_USER_POPUP_DATE_BIRTH_INPUT',
      USERS_WIDGET_ADD_USER_POPUP_NUMBER_TEL_INPUT: 'USERS_WIDGET_ADD_USER_POPUP_NUMBER_TEL_INPUT',
      USERS_WIDGET_ADD_USER_POPUP_EMAIL_INPUT: 'USERS_WIDGET_ADD_USER_POPUP_EMAIL_INPUT',
      USERS_WIDGET_ADD_USER_POPUP_PASSWORD_INPUT: 'USERS_WIDGET_ADD_USER_POPUP_PASSWORD_INPUT',
      USERS_WIDGET_ADD_USER_POPUP_ROLE_INPUT: 'USERS_WIDGET_ADD_USER_POPUP_ROLE_INPUT',
      USERS_WIDGET_ADD_USER_POPUP_ROLE_LIST: 'USERS_WIDGET_ADD_USER_POPUP_ROLE_LIST',
      USERS_WIDGET_ADD_USER_POPUP_ROLE_LIST_ITEM: 'USERS_WIDGET_ADD_USER_POPUP_ROLE_LIST_ITEM',
      USERS_WIDGET_ADD_USER_POPUP_ACCESS_INPUT: 'USERS_WIDGET_ADD_USER_POPUP_ACCESS_INPUT',
      USERS_WIDGET_ADD_USER_POPUP_ACCESS_LIST: 'USERS_WIDGET_ADD_USER_POPUP_ACCESS_LIST',
      USERS_WIDGET_ADD_USER_POPUP_ACCESS_LIST_ITEM: 'USERS_WIDGET_ADD_USER_POPUP_ACCESS_LIST_ITEM',
      USERS_WIDGET_ADD_USER_POPUP_DRIVING_PERMIT_INPUT:
        'USERS_WIDGET_ADD_USER_POPUP_DRIVING_PERMIT_INPUT',
      USERS_WIDGET_ADD_USER_POPUP_DATE_PERMIT_ADD_INPUT:
        'USERS_WIDGET_ADD_USER_POPUP_DATE_PERMIT_ADD_INPUT',
      USERS_WIDGET_ADD_USER_POPUP_DATE_PERMIT_END_INPUT:
        'USERS_WIDGET_ADD_USER_POPUP_DATE_PERMIT_END_INPUT',
      USERS_WIDGET_ADD_USER_POPUP_CATEGORIES_INPUT: 'USERS_WIDGET_ADD_USER_POPUP_CATEGORIES_INPUT',
    },
  },

  page_roles: {
    roles_popup_add_role: {
      ROLES_ADD_ROLE_NAME: 'ROLES_ADD_ROLE_NAME',
      ROLES_ADD_ROLE_USERS_PERMISSIONS: 'ROLES_ADD_ROLE_USERS_PERMISSIONS',
      ROLES_ADD_ROLE_CAR_PERMISSIONS: 'ROLES_ADD_ROLE_CAR_PERMISSIONS',
      ROLES_ADD_ROLE_ALCOLOCK_PERMISSIONS: 'ROLES_ADD_ROLE_ALCOLOCK_PERMISSIONS',
      ROLES_ADD_ROLE_ATTACHMENTS_PERMISSIONS: 'ROLES_ADD_ROLE_ATTACHMENTS_PERMISSIONS',
    },
    roles_widget_header: {
      ROLES_WIDGET_HEADER_SEARCH_INPUT: 'ROLES_WIDGET_HEADER_SEARCH_INPUT',
      ROLES_WIDGET_HEADER_FROM_DATE: 'ROLES_WIDGET_HEADER_FROM_DATE',
      ROLES_WIDGET_HEADER_TO_DATE: 'ROLES_WIDGET_HEADER_TO_DATE',
    },
    roles_widget_table: {
      ROLES_WIDGET_TABLE: 'ROLES_WIDGET_TABLE',
      ROLES_WIDGET_TABLE_HEADER_ITEM: 'ROLES_WIDGET_TABLE_HEADER_ITEM',
      ROLES_WIDGET_TABLE_BODY_ITEM: 'ROLES_WIDGET_TABLE_BODY_ITEM',
      ROLES_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT: 'ROLES_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT',
      ROLES_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE: 'ROLES_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE',
      ROLES_WIDGET_TABLE_BODY_ITEM_ACTION_ADD: 'ROLES_WIDGET_TABLE_BODY_ITEM_ACTION_ADD',
    },
  },

  page_groups: {
    groups_widget_header: {
      GROUPS_WIDGET_HEADER_SEARCH_INPUT: 'GROUPS_WIDGET_HEADER_SEARCH_INPUT',
      GROUPS_WIDGET_HEADER_FROM_DATE: 'GROUPS_WIDGET_HEADER_FROM_DATE',
      GROUPS_WIDGET_HEADER_TO_DATE: 'GROUPS_WIDGET_HEADER_TO_DATE',
    },
    groups_widget_table: {
      GROUPS_WIDGET_TABLE: 'GROUPS_WIDGET_TABLE',
      GROUPS_WIDGET_TABLE_HEADER_ITEM: 'GROUPS_WIDGET_TABLE_HEADER_ITEM',
      GROUPS_WIDGET_TABLE_BODY_ITEM: 'GROUPS_WIDGET_TABLE_BODY_ITEM',
      GROUPS_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT: 'GROUPS_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT',
      GROUPS_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE: 'GROUPS_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE',
      GROUPS_WIDGET_TABLE_HEADER_ITEM_OPEN_MODAL: 'GROUPS_WIDGET_TABLE_HEADER_ITEM_OPEN_MODAL',
    },
    groups_widget_info: {
      GROUPS_WIDGET_INFO_TAB_USERS_BUTTON: 'GROUPS_WIDGET_INFO_TAB_USERS_BUTTON',
      GROUPS_WIDGET_INFO_TAB_USERS_TABLE: 'GROUPS_WIDGET_INFO_TAB_USERS_TABLE',
      GROUPS_WIDGET_INFO_TAB_USERS_INPUT_SEARCH: 'GROUPS_WIDGET_INFO_TAB_USERS_INPUT_SEARCH',
      GROUPS_WIDGET_INFO_TAB_TABLE_HEADER: 'GROUPS_WIDGET_INFO_TAB_TABLE_HEADER',
      GROUPS_WIDGET_INFO_TAB_ALCOLOCKS_TABLE: 'GROUPS_WIDGET_INFO_TAB_ALCOLOCKS_TABLE',
      GROUPS_WIDGET_INFO_TAB_ALCOLOCKS_BUTTON: 'GROUPS_WIDGET_INFO_TAB_ALCOLOCKS_BUTTON',
      GROUPS_WIDGET_INFO_TAB_TRANSPORT_USERS_BUTTON: 'USERS_WIDGET_INFO_TAB_TRANSPORT_BUTTON',
      GROUPS_WIDGET_INFO_TAB_CARS_TABLE: 'GROUPS_WIDGET_INFO_TAB_CARS_TABLE',
    },
  },

  page_transports: {
    transports_widget_add_car_popup: {
      CAR_POPUP_YEAR: 'CAR_POPUP_YEAR',
      CAR_POPUP_COLOR: 'CAR_POPUP_COLOR',
      CAR_POPUP_TYPE: 'CAR_POPUP_TYPE',
    },
    transports_widget_header: {
      TRANSPORT_WIDGET_HEADER_SEARCH_INPUT: 'TRANSPORT_WIDGET_HEADER_SEARCH_INPUT',
      TRANSPORT_WIDGET_HEADER_FROM_DATE: 'TRANSPORT_WIDGET_HEADER_FROM_DATE',
      TRANSPORT_WIDGET_HEADER_TO_DATE: 'TRANSPORT_WIDGET_HEADER_TO_DATE',
    },
    transports_widget_table: {
      TRANSPORT_WIDGET_TABLE: 'TRANSPORT_WIDGET_TABLE',
      TRANSPORT_WIDGET_TABLE_HEADER_ITEM: 'TRANSPORT_WIDGET_TABLE_HEADER_ITEM',
      TRANSPORT_WIDGET_TABLE_BODY_ITEM: 'TRANSPORT_WIDGET_TABLE_BODY_ITEM',
      TRANSPORT_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT: 'TRANSPORT_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT',
      TRANSPORT_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE:
        'TRANSPORT_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE',
      TRANSPORT_WIDGET_TABLE_HEADER_ITEM_OPEN_MODAL:
        'TRANSPORT_WIDGET_TABLE_HEADER_ITEM_OPEN_MODAL',
      TRANSPORT_WIDGET_TABLE_ADD_OR_CHANGE_MODAL: 'TRANSPORT_WIDGET_TABLE_ADD_OR_CHANGE_MODAL',
    },
    transports_widget_info: {
      TRANSPORTS_WIDGET_INFO_TAB_BUTTON_INFO: 'TRANSPORTS_WIDGET_INFO_TAB_BUTTON_INFO',
      TRANSPORTS_WIDGET_INFO_TAB_BUTTON_HISTORY: 'TRANSPORTS_WIDGET_INFO_TAB_BUTTON_HISTORY',
    },
  },
  page_alcolocks: {
    alcolocks_widget_header: {
      ALCOLOCKS_WIDGET_HEADER_SEARCH_INPUT: 'ALCOLOCKS_WIDGET_HEADER_SEARCH_INPUT',
      ALCOLOCKS_WIDGET_HEADER_FROM_DATE: 'ALCOLOCKS_WIDGET_HEADER_FROM_DATE',
      ALCOLOCKS_WIDGET_HEADER_TO_DATE: 'ALCOLOCKS_WIDGET_HEADER_TO_DATE',
    },
    alcolocks_widget_table: {
      ALCOLOCKS_WIDGET_TABLE: 'ALCOLOCKS_WIDGET_TABLE',
      ALCOLOCKS_WIDGET_TABLE_HEADER_ITEM: 'ALCOLOCKS_WIDGET_TABLE_HEADER_ITEM',
      ALCOLOCKS_WIDGET_TABLE_BODY_ITEM: 'ALCOLOCKS_WIDGET_TABLE_BODY_ITEM',
      ALCOLOCKS_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT: 'ALCOLOCKS_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT',
      ALCOLOCKS_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE:
        'ALCOLOCKS_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE',
      ALCOLOCKS_WIDGET_TABLE_BODY_ITEM_ACTION_ADD: 'ALCOLOCKS_WIDGET_TABLE_BODY_ITEM_ACTION_ADD',
    },
    alcolocks_widget_info: {
      ALCOLOCKS_WIDGET_INFO_TAB_BUTTON_INFO: 'ALCOLOCKS_WIDGET_INFO_TAB_BUTTON_INFO',
      ALCOLOCKS_WIDGET_INFO_TAB_BUTTON_HISTORY: 'ALCOLOCKS_WIDGET_INFO_TAB_BUTTON_HISTORY',
      ALCOLOCKS_WIDGET_INFO_AVTOSERVISE_BUTTON_ON: 'ALCOLOCKS_WIDGET_INFO_AVTOSERVISE_BUTTON_ON',
      ALCOLOCKS_WIDGET_INFO_AVTOSERVISE_BUTTON_OFF: 'ALCOLOCKS_WIDGET_INFO_AVTOSERVISE_BUTTON_OFF',
    },
    alcolocks_popup_add_alcolock: {
      ALCOLOCK_ADD_ATTACH_INPUT_CAR: 'ALCOLOCK_ADD_ATTACH_INPUT_CAR',
    },
  },
  page_avto_service: {
    avto_service_widget_header: {
      AVTO_SERVICE_WIDGET_HEADER_SEARCH_INPUT: 'AVTO_SERVICE_WIDGET_HEADER_SEARCH_INPUT',
      AVTO_SERVICE_WIDGET_HEADER_FROM_DATE: 'AVTO_SERVICE_WIDGET_HEADER_FROM_DATE',
      AVTO_SERVICE_WIDGET_HEADER_TO_DATE: 'AVTO_SERVICE_WIDGET_HEADER_TO_DATE',
    },
    avto_service_widget_table: {
      AVTO_SERVICE_WIDGET_TABLE: 'AVTO_SERVICE_WIDGET_TABLE',
      AVTO_SERVICE_WIDGET_TABLE_HEADER_ITEM: 'AVTO_SERVICE_WIDGET_TABLE_HEADER_ITEM',
      AVTO_SERVICE_WIDGET_TABLE_BODY_ITEM: 'AVTO_SERVICE_WIDGET_TABLE_BODY_ITEM',
      AVTO_SERVICE_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT:
        'AVTO_SERVICE_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT',
      AVTO_SERVICE_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE:
        'AVTO_SERVICE_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE',
    },
  },
  page_attachments: {
    attachments_widget_header: {
      ATTACHMENTS_WIDGET_HEADER_SEARCH_INPUT: 'ATTACHMENTS_WIDGET_HEADER_SEARCH_INPUT',
      ATTACHMENTS_WIDGET_HEADER_FROM_DATE: 'ATTACHMENTS_WIDGET_HEADER_FROM_DATE',
      ATTACHMENTS_WIDGET_HEADER_TO_DATE: 'ATTACHMENTS_WIDGET_HEADER_TO_DATE',
      ATTACHMENTS_WIDGET_HEADER_FILTER_BUTTON: 'ATTACHMENTS_WIDGET_HEADER_FILTER_BUTTON',
      ATTACHMENTS_WIDGET_HEADER_FILTER_INPUT_DRIVER:
        'ATTACHMENTS_WIDGET_HEADER_FILTER_INPUT_DRIVER',
      ATTACHMENTS_WIDGET_HEADER_FILTER_INPUT_CAR: 'ATTACHMENTS_WIDGET_HEADER_FILTER_INPUT_CAR',
      ATTACHMENTS_WIDGET_HEADER_FILTER_INPUT_ALCOLOKS:
        'ATTACHMENTS_WIDGET_HEADER_FILTER_INPUT_ALCOLOKS',
      ATTACHMENTS_WIDGET_HEADER_FILTER_INPUT_CREATE_LINK:
        'ATTACHMENTS_WIDGET_HEADER_FILTER_INPUT_CREATE_LINK',
      ATTACHMENTS_WIDGET_HEADER_FILTER_INPUT_DATE_LINK:
        'ATTACHMENTS_WIDGET_HEADER_FILTER_INPUT_DATE_LINK',
    },
    attachments_widget_table: {
      ATTACHMENTS_WIDGET_TABLE_HEADER_ITEM_OPEN_MODAL:
        'ATTACHMENTS_WIDGET_TABLE_HEADER_ITEM_OPEN_MODAL',
      ATTACHMENTS_WIDGET_TABLE: 'ATTACHMENTS_WIDGET_TABLE',
      ATTACHMENTS_WIDGET_TABLE_HEADER_ITEM: 'ATTACHMENTS_WIDGET_TABLE_HEADER_ITEM',
      ATTACHMENTS_WIDGET_TABLE_BODY_ITEM: 'ATTACHMENTS_WIDGET_TABLE_BODY_ITEM',
      ATTACHMENTS_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT:
        'ATTACHMENTS_WIDGET_TABLE_BODY_ITEM_ACTION_EDIT',
      ATTACHMENTS_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE:
        'ATTACHMENTS_WIDGET_TABLE_BODY_ITEM_ACTION_DELETE',
    },
    attachments_popup_add_attach: {
      ATTACHMENTS_ADD_ATTACH: 'ATTACHMENTS_ADD_ATTACH',
      ATTACHMENTS_ADD_ATTACH_INPUT_CAR: 'ATTACHMENTS_ADD_ATTACH_INPUT_CAR',
      ATTACHMENTS_ADD_ATTACH_INPUT_USER: 'ATTACHMENTS_ADD_ATTACH_INPUT_USER',
    },
    attachments_popup_delete_attach: {
      ATTACHMENTS_DELETE_ATTACH: 'ATTACHMENTS_DELETE_ATTACH',
    },
  },
};
